import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=87c9f8f8"
import script from "./tooltip.vue?vue&type=script&lang=js"
export * from "./tooltip.vue?vue&type=script&lang=js"
import style0 from "./tooltip.vue?vue&type=style&index=0&id=87c9f8f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports